import React from 'react';
import {useStyles} from "../BillingPeriod.style";
import clsx from "clsx";
import BillingPeriodRowProperties from "./BillingPeriodRowProperties";
import ShowSellerBasicInfo from "../../../shared_components/Info/ShowSellerBasicInfo/ShowSellerBasicInfo";
// import RemoveBillingPeriodButton from "../../../shared_components/Buttons/RemoveBillingPeriodButton/RemoveBillingPeriodButton";
// import NewBillingPeriodButton from '../../../shared_components/Buttons/NewBillingPeriodButton/NewBillingPeriodButton';


const BillingPeriodRowSmall: React.FC<BillingPeriodRowProperties> = ({billingPeriod, onUpdate}) => {

    const classes = useStyles();

    return (
        <div className={clsx(classes.billing_period_info_container_small)}>
            <ShowSellerBasicInfo autofill name={'billingPeriod.name'} email={'billingPeriod.name'}/>
            <div className={classes.menu_container_small}>
                {/* <NewBillingPeriodButton
                    size={ButtonSize.SMALL}
                    onSave={onUpdate}
                    billingPeriodId={billingPeriod.id}
                    showText={false}
                    type={ButtonType.SECONDARY}
                />
                <RemoveBillingPeriodButton
                    size={ButtonSize.SMALL}
                    onSave={onUpdate}
                    billingPeriod={billingPeriod}
                    showText={false}
                    type={ButtonType.SECONDARY}
                /> */}
            </div>
        </div>
    )
}

export default BillingPeriodRowSmall;
